import { render, staticRenderFns } from "./ColorBrightness.vue?vue&type=template&id=cadafa48&scoped=true&"
import script from "./ColorBrightness.vue?vue&type=script&lang=js&"
export * from "./ColorBrightness.vue?vue&type=script&lang=js&"
import style0 from "./ColorBrightness.vue?vue&type=style&index=0&id=cadafa48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadafa48",
  null
  
)

export default component.exports